import { ApiResponse } from "@/utils/ApiResponse";
import { PaginacionFilterParams } from "@/utils/PaginacionFilterParams";
import apiClient from "@/clients/apiClient";
import { MarcaProductoInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProducto.interface";

export async function ListMarcaProductoAction(
  paginacionFilterParams: PaginacionFilterParams
): Promise<ApiResponse<MarcaProductoInterface>> {
  const { data } = await apiClient.get<MarcaProductoInterface>(
    "/gpMarcaProductos",
    {
      params: paginacionFilterParams,
    }
  );
  return {
    status: 200,
    data,
    message: "Marca de productos obtenidas correctamente",
  };
}
